import React from 'react'
import { useTranslation } from 'react-i18next'

import { KPI } from '../../../../../components/kpi'
import { useEInvoiceCockpitKpis } from '../../data'

export const KPIs: React.FC = () => {
  const { t, i18n } = useTranslation('eInvoiceCockpit')
  const { data: kpis, isLoading, error } = useEInvoiceCockpitKpis()

  return (
    <>
      <div className="col-12 sm:col-6 lg:col-3">
        <KPI
          title={t('kpis.invoices.title')}
          icon="pi-chart-bar"
          value={kpis?.totalHistoricEInvoices || 0}
          valueSuffix={t('kpis.invoices.suffix', {
            count: kpis?.totalHistoricEInvoices,
          })}
          // change={-3}
          // changeSuffix={t('kpis.invoices.change')}
        />
      </div>

      <div className="col-12 sm:col-6 lg:col-3">
        <KPI
          title={t('kpis.openCases.title')}
          icon="pi-folder"
          value={kpis?.totalEInvoices || 0}
          valueSuffix={t('kpis.openCases.suffix', {
            count: kpis?.totalEInvoices,
          })}
          // change={2}
          // changeSuffix={t('kpis.openCases.change')}
        />
      </div>

      <div className="col-12 sm:col-6 lg:col-3">
        <KPI
          title={t('kpis.dueAmountsGross.title')}
          icon="pi-euro"
          value={
            kpis?.totalAmountActiveEInvoices.toLocaleString(i18n.language, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }) || 0
          }
          valueSuffix="€"
          // change={3}
          // changeSuffix={t('kpis.dueAmountsGross.change')}
        />
      </div>

      <div className="col-12 sm:col-6 lg:col-3">
        <KPI
          title={t('kpis.avgDaysUnprocessed.title')}
          icon="pi-clock"
          value={kpis?.averageDaysOfUnprocessedEInvoices || 0}
          valueSuffix={t('kpis.avgDaysUnprocessed.suffix', {
            count: kpis?.averageDaysOfUnprocessedEInvoices,
          })}
          // change={1}
          // changeSuffix={t('kpis.avgDaysUnprocessed.change')}
        />
      </div>
    </>
  )
}
